import { combineReducers } from 'redux'
import ids from './ids'
import params from './params'
import total from './total'

// Pass options to all reducers (we might need them at some point)
export default (resource, options) =>
  combineReducers({
    ids: ids(resource, options),
    params: params(resource, options),
    total: total(resource, options),
  })



// WEBPACK FOOTER //
// ./state/reducers/resource/list/index.js